import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/tenants.js';
import { h } from '../index.js';
import q from '../query.js';
export { useTenantId, setTenantId, getTenantId, initTenantId, } from './selected.js';
import { useTenantId } from './selected.js';
export const tenantsEntity = `tenants`;
const tenantsKey = `all-tenants`;
export const useTenants = () => q.query(tenantsKey, api.getAll, keys.read.collection(tenantsEntity));
const tenantKey = 'tenant';
export const useTenantById = (tenantId) => q.query(tenantKey, () => api.get(tenantId), keys.read.item(tenantsEntity, tenantId), { enabled: tenantId != null });
export const useTenantLoadable = () => {
    const tenantId = useTenantId();
    return useTenantById(tenantId);
};
export const useTenant = () => {
    const tenantLoadable = useTenantLoadable();
    return h.hasData(tenantLoadable) ? tenantLoadable.data : null;
};
export const ensureTenantLoaded = () => q.ensureLoaded(tenantKey);
const tenantSSOOverviewKey = (tenantId) => `tenant-sso:${tenantId}`;
export const useTenantSSOOverview = (tenantId) => q.query(tenantSSOOverviewKey(tenantId), () => api.getSSOOverview(tenantId), keys.read.item(tenantsEntity, tenantId), { enabled: tenantId != null });
//# sourceMappingURL=index.js.map